import { useEffect, useState } from "react";
import { Offers } from "../lib/api";
import { Flame, X } from "lucide-react";

export default function OffersBanner() {
  const [offers, setOffers] = useState([]);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    Offers.list().then(setOffers).catch(() => setOffers([]));
  }, []);

  if (hidden || offers.length === 0) return null;
  const o = offers[0];

  return (
    <div
      data-testid="offers-banner"
      className="bg-[#D92525] text-white border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-2 flex items-center gap-3">
        <Flame size={16} strokeWidth={3} className="text-[#FFB800] shrink-0" />
        <div className="flex-1 text-sm md:text-base font-semibold truncate">
          <span className="font-display uppercase tracking-wide mr-2">
            Today's Offer:
          </span>
          {o.title}
          {o.price != null && (
            <span className="ml-2 text-[#FFB800] font-bold">@ ₹{o.price}</span>
          )}
        </div>
        <a
          href="#offers"
          className="hidden sm:inline-block brutal-border bg-[#FFB800] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest"
        >
          See All
        </a>
        <button
          onClick={() => setHidden(true)}
          aria-label="dismiss"
          className="text-white/80 hover:text-white"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
